































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ITelemetryPm2Process } from "@/@types/servers/telemetry";
import StandartTable from "@/components/tables/standart-table.vue";

@Component({
  components: { StandartTable },
})
export default class Pm2Table extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly processes!: ITelemetryPm2Process[];

  restarting: string | null = null;
  stopping: string | null = null;

  get sortedProcesses(): ITelemetryPm2Process[] {
    return [...this.processes].sort((a, b) => {
      if (a.status === "online" && b.status !== "online") return -1;
      if (a.status !== "online" && b.status === "online") return 1;
      return a.name.localeCompare(b.name);
    });
  }

  get onlineCount(): number {
    return this.processes.filter((p) => p.status === "online").length;
  }

  get stoppedCount(): number {
    return this.processes.filter((p) => p.status === "stopped").length;
  }

  cpuBarClass(cpu: number): string {
    if (cpu > 50) return "cpu-high";
    if (cpu > 10) return "cpu-mid";
    return "cpu-low";
  }

  formatBytes(bytes: number): string {
    if (bytes === 0) return "0 B";
    const mb = bytes / (1024 * 1024);
    if (mb >= 1) return mb.toFixed(1) + " MB";
    const kb = bytes / 1024;
    return kb.toFixed(0) + " KB";
  }

  formatUptime(ms: number): string {
    const sec = Math.floor(ms / 1000);
    const min = Math.floor(sec / 60);
    const hr = Math.floor(min / 60);
    const day = Math.floor(hr / 24);
    if (day > 0) return `${day}d ${hr % 24}h`;
    if (hr > 0) return `${hr}h ${min % 60}m`;
    if (min > 0) return `${min}m ${sec % 60}s`;
    return `${sec}s`;
  }

  restartProcess(proc: ITelemetryPm2Process): void {
    if (this.restarting || this.stopping) return;
    this.restarting = proc.name;
    this.$emit("restart", proc.name);
    setTimeout(() => {
      this.restarting = null;
    }, 3000);
  }

  stopProcess(proc: ITelemetryPm2Process): void {
    if (this.restarting || this.stopping) return;
    this.stopping = proc.name;
    this.$emit("stop", proc.name);
    setTimeout(() => {
      this.stopping = null;
    }, 3000);
  }
}
